<template>
    <BaseModal v-model="modalShow" size="xl" :scrollable="false">
      <KarinForm class="container"></KarinForm>
  </BaseModal>
</template>
<script>
import { EventNames } from '@/plugins/enums/index.js'
import BaseModal from '@/components/shared/Base-modal.vue';
import KarinForm from "@/components/KarinLaw/KarinMenu/Karin-form.vue";

export default {
  name: 'KarinFormModal',

  components: {    BaseModal,
    KarinForm
  },

  data() {
    return {
      modalShow: false,
    }
  },

  async mounted() {
    this.$eventBus.$on(EventNames.KarinOpenCreateModal, async () => {
      this.modalShow = true;
    });
  },
}
</script>

<style scoped>
.container {
  overflow-y: auto;
  max-height: 75vh;
}
</style>
